import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventDetailsImage, EventDetailsModel } from "./event-details.model";
import { EventDetailsService } from "./event-details.service";
import { EnumModel } from "../../shared/objects/EnumModel";
import { Toast, ToasterService } from "angular2-toaster";

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.less'],
  providers: [EventDetailsService]
})
export class EventDetailsComponent implements OnInit {
  @Input() eventId: number;
  @Input() cloneFromModel: boolean;
  @Output() showEventClosed = new EventEmitter<boolean>();
  something = {};
  activeTab = 1;
  now = new Date();
  dateFrom = new Date();
  dateTo = new Date();
  timeFrom = new Date();
  timeTo = new Date();
  deadlineDate = new Date();
  deadlineTime = new Date();
  geocoder: any = new google.maps.Geocoder();

  numberOfAttendees = 5;
  numberOfAttendeesPerMember = 2;
  description = '';
  address = '';
  name = '';
  subtitle = '';
  images = new Array<EventDetailsImage>();
  timeNotSet = true;
  timeNotSetTo = true;

  buttonsEnabled = true;
  latitude = 41;
  longitude = 0;
  map: any;

  isLoading = false;

  showDeleteConfirmation = false;
  showSaveConfirmation = false;

  isAlive: boolean;
  initAliveState: boolean;
  model: any;

  mailChimpTemplates: Array<EnumModel>;
  eventTypes: Array<EnumModel>;
  mailChimpTemplatesFollowup: Array<EnumModel>;
  selectedMailChimpTemplates: EnumModel;
  selectedEventType: EnumModel;

  followupOptions: Array<EnumModel>;
  selectedFollowupOption: EnumModel;
  selectedFollowupTemplate: EnumModel;

  appResponseAttending = '';
  appResponseWaitingList = '';
  files: any[];

  initialState: string;
  showCloseConfirmation = false;
  closeRefreshState = false;
  loaded: boolean;
  isBulkNotifications = false;

  constructor(private service: EventDetailsService, private toasterService: ToasterService) {
  }

  ngOnInit() {


    this.followupOptions = new Array<EnumModel>();

    this.followupOptions.push(new EnumModel('0', 'None'));
    this.followupOptions.push(new EnumModel('8', '8 hours before'));
    this.followupOptions.push(new EnumModel('48', '48 hours before'));

    this.eventTypes = new Array<EnumModel>();
    this.eventTypes.push(new EnumModel('false', 'Event'));
    this.eventTypes.push(new EnumModel('true', 'Ongoing'));

    if (this.eventId) {
      this.service.getEventDetails(this.eventId).subscribe(
        (response) => {
          this.model = response;
          this.initFromModel();
          this.loaded = true;
          this.service.getMailTemplates().subscribe(
            (r) => {
              this.mailChimpTemplates = r.filter(x => x.id.indexOf('event-rvsp-confirmation') > -1);
              this.mailChimpTemplatesFollowup = r.filter(x => x.id.indexOf('event-followup') > -1);
              this.selectedMailChimpTemplates = EnumModel.GetByIdOrFirst(this.mailChimpTemplates, this.model.mailTemplateAttending);
              this.selectedFollowupTemplate = EnumModel.GetByIdOrFirst(this.mailChimpTemplatesFollowup, this.model.mailTemplateFollowUp);
              this.selectedFollowupOption = EnumModel.GetByIdOrFirst(this.followupOptions, this.model.hoursBeforeFollowupEmail);

              this.saveInitialState();
            }
          );
        });
    } else {
      this.model = new EventDetailsModel();
      this.selectedEventType = EnumModel.GetByIdOrFirst(this.eventTypes, this.model.ongoing);
      this.service.getMailTemplates().subscribe(
        (r) => {
          this.loaded = true;
          this.mailChimpTemplates = r.filter(x => x.id.indexOf('event-rvsp-confirmation') > -1);
          this.mailChimpTemplatesFollowup = r.filter(x => x.id.indexOf('event-followup') > -1);
          this.selectedMailChimpTemplates = EnumModel.GetByIdOrFirst(this.mailChimpTemplates, this.model.mailTemplateAttending);
          this.selectedFollowupTemplate = EnumModel.GetByIdOrFirst(this.mailChimpTemplatesFollowup, this.model.mailTemplateFollowUp);
          this.selectedFollowupOption = EnumModel.GetByIdOrFirst(this.followupOptions, this.model.hoursBeforeFollowupEmail);
          this.saveInitialState();
        }
      );
    }

  }

  initFromModel() {
    this.name = this.model.name;
    this.subtitle = this.model.subtitle;
    this.timeNotSet = this.model.timeNotSet;
    this.timeNotSetTo = this.model.timeNotSetTo;
    this.timeFrom = this.timeNotSet ? null : new Date(this.model.timeFrom.substring(0, this.model.timeFrom.length - 1));
    this.timeTo = this.timeNotSetTo ? null : new Date(this.model.timeTo.substring(0, this.model.timeTo.length - 1));
    this.dateFrom = this.model.timeFrom ? new Date(this.model.timeFrom.substring(0, this.model.timeFrom.length - 1)) : new Date();
    this.dateTo = this.model.timeTo ? new Date(this.model.timeTo.substring(0, this.model.timeTo.length - 1)) : new Date();
    this.deadlineDate = new Date(this.model.deadLine.substring(0, this.model.deadLine.length - 1));
    this.deadlineTime = new Date(this.model.deadLine.substring(0, this.model.deadLine.length - 1));
    this.numberOfAttendees = this.model.maxNumberOfAttendees;
    this.numberOfAttendeesPerMember = this.model.maxNumberOfGuestPerUser;
    this.description = this.model.description;
    this.address = this.model.location;
    this.longitude = this.model.longitude;
    this.latitude = this.model.latitude;
    this.appResponseAttending = this.model.appResponseAttending;
    this.appResponseWaitingList = this.model.appResponseWaiting;
    this.images = this.model.images;
    this.isAlive = this.model.isAlive;
    this.initAliveState = this.model.isAlive;
    this.selectedEventType = EnumModel.GetByIdOrFirst(this.eventTypes, this.model.ongoing);

    this.initGeolocation();
  }

  initGeolocation() {
    setTimeout(() => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: this.latitude, lng: this.longitude },
        zoom: 17,
        disableDefaultUI: true
      });
      const marker = new google.maps.Marker({
        map: this.map,
        position: { lat: this.latitude, lng: this.longitude },

      });

    }, 100);
  }

  codeAddress() {
    let position;
    this.geocoder.geocode({ 'address': this.address }, (results, status) => {
      if (status === 'OK') {
        this.map = new google.maps.Map(document.getElementById('map'), {
          zoom: 17,
          disableDefaultUI: true
        });
        position = results[0].geometry.location;
        this.map.setCenter(results[0].geometry.location);
        const marker = new google.maps.Marker({
          map: this.map,
          position: results[0].geometry.location,
        });
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });

    setTimeout(() => {
      this.latitude = position.lat();
      this.longitude = position.lng();
    }, 1000);

  }

  close(refresh = false) {

    if (this.buttonsEnabled) {
      this.closeRefreshState = refresh;
      if (this.StateChanged()) {
        this.showCloseConfirmation = true;
      } else {
        this.closeConfirmed();
      }
    }
  }

  closeConfirmed() {
    this.showEventClosed.emit(this.closeRefreshState);
  }

  changeTab(index) {
    this.activeTab = index;

  }

  addImage(e) {
    const component = this;
    const files: any = <HTMLElement>e.target.files;
    for (let i = 0; i < files.length; i++) {
      if (this.images.length > 3) {
        break;
      }
      const urlStringReader = new FileReader();
      const file = files[i];
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is not an image',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);
        continue;
      }

      if (file.size > 1048576) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is larger then 1mb',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }
      urlStringReader.addEventListener('load', function (event: any) {
        const src = event.target.result;
        const newRImage = new EventDetailsImage();
        newRImage.url = src;
        newRImage.mime = '';
        newRImage.data = file;
        component.images.push(newRImage);
        e.target.value = '';
      });
      urlStringReader.readAsDataURL(file);
    }
  }

  removeImage(img) {
    this.images.splice(this.images.indexOf(img), 1);
  }

  delete() {
    this.showDeleteConfirmation = true;
  }

  deleteConfirmed() {
    if (!this.cloneFromModel) {
      this.service.delete(this.model.id)
        .subscribe(
          (response) => {
            this.showEventClosed.emit(true);
          }, (error) => {
            this.buttonsEnabled = true;
          });
    }
  }

  openPopUp() {
    if (this.isAlive && !this.initAliveState) {
      this.showSaveConfirmation = true;
    } else {
      this.save();
    }
  }

  openPopUpNotLive() {
    this.showSaveConfirmation = true;
  }

  selectSave() {
    this.isLoading = true;
    if (this.isAlive) {
      this.save();
    } else {
      this.saveAndGoLive()
    }

  }

  updateBulkNotifications(notify: boolean) {
    this.isBulkNotifications = notify;
  }

  save() {
    this.populateModel();
    this.saveOrUpdate();
  }

  populateModel() {
    this.model.name = this.name;
    this.model.subtitle = this.subtitle;
    this.model.timeNotSet = this.timeFrom == null;
    this.model.timeNotSetTo = this.timeTo == null;
    this.model.ongoing = this.selectedEventType.id == 'true';
    this.model.isBulkNotifications = this.isBulkNotifications;

    if (!this.model.ongoing) {
      this.model.timeFrom = new Date(Date.UTC(this.dateFrom.getFullYear(), this.dateFrom.getMonth(),
        this.dateFrom.getDate(), this.timeFrom ? this.timeFrom.getHours() : 0,
        this.timeFrom ? this.timeFrom.getMinutes() : 0));

      if (!this.dateTo) {
        this.model.timeTo = new Date(Date.UTC(this.dateFrom.getFullYear(), this.dateFrom.getMonth(),
          this.dateFrom.getDate(), this.timeTo ? this.timeTo.getHours() : 0,
          this.timeTo ? this.timeTo.getMinutes() : 0));
      }
      else {
        this.model.timeTo = new Date(Date.UTC(this.dateTo.getFullYear(), this.dateTo.getMonth(),
          this.dateTo.getDate(), this.timeTo ? this.timeTo.getHours() : 0,
          this.timeTo ? this.timeTo.getMinutes() : 0));
      }
    }
    else {
      this.model.timeFrom = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(),
        new Date().getDate(), this.timeFrom ? this.timeFrom.getHours() : 0,
        this.timeFrom ? this.timeFrom.getMinutes() : 0));

      this.model.timeTo = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(),
        new Date().getDate(), this.timeTo ? this.timeTo.getHours() : 0,
        this.timeTo ? this.timeTo.getMinutes() : 0));
    }


    this.model.deadLine = new Date(Date.UTC(this.deadlineDate.getFullYear(), this.deadlineDate.getMonth(),
      this.deadlineDate.getDate(), this.deadlineTime.getHours(),
      this.deadlineTime.getMinutes()));
    this.model.maxNumberOfAttendees = this.numberOfAttendees;
    this.model.maxNumberOfGuestPerUser = this.numberOfAttendeesPerMember;
    this.model.description = '';
    this.model.location = this.address;
    this.model.longitude = this.longitude;
    this.model.latitude = this.latitude;
    this.model.appResponseAttending = '';
    this.model.appResponseWaiting = '';
    this.model.mailTemplateAttending = this.selectedMailChimpTemplates.id;
    this.model.mailTemplateFollowUp = this.selectedFollowupTemplate.id;
    this.model.hoursBeforeFollowupEmail = this.selectedFollowupOption.id;
    this.model.isAlive = this.isAlive;

    this.files = new Array<File>();
    this.model.images = new Array<EventDetailsImage>();
    if (this.images.length > 0) {
      for (const img of this.images) {
        if (img.data) {
          this.files.push(img.data);
          img.fileIndex = this.files.indexOf(img.data);
          const newImg = JSON.parse(JSON.stringify(img));
          newImg.data = null;
          newImg.url = null;
          this.model.images.push(newImg);
        } else {
          this.model.images.push(img);
        }
      }
    }
  }

  saveOrUpdate() {
    this.buttonsEnabled = false;
    if (this.model.id !== 0 && !this.cloneFromModel) {
      this.service.update(this.model, this.files)
        .subscribe(
          (response) => {

            this.service.updateEventHtmlFields({
              eventId: this.model.id,
              description: this.description,
              appResponseAttending: this.appResponseAttending,
              appResponseWaiting: this.appResponseWaitingList,
              isMembershipCard: this.model.isMembershipCard
            }).subscribe(
              (res) => {
                this.showEventClosed.emit(true);
              }, (error) => {
                this.buttonsEnabled = true;
              });


          }, (error) => {
            this.buttonsEnabled = true;
          });
    } else {
      this.service.new(this.model, this.files).subscribe(
        (id) => {

          this.service.updateEventHtmlFields({
            eventId: id,
            description: this.description,
            appResponseAttending: this.appResponseAttending,
            appResponseWaiting: this.appResponseWaitingList,
            isMembershipCard: this.model.isMembershipCard
          }).subscribe(
            (res) => {
              this.showEventClosed.emit(true);
            }, (error) => {
              this.buttonsEnabled = true;
            });

        }, (error) => {
          this.buttonsEnabled = true;
        });
    }
  }

  saveAndGoLive() {
    this.populateModel();
    this.model.isAlive = true;
    this.saveOrUpdate();
  }

  unpublish() {
    this.populateModel();
    this.model.isAlive = false;
    this.saveOrUpdate();
  }

  closePopUp() {
    this.showDeleteConfirmation = false;
    this.showCloseConfirmation = false;
    this.showSaveConfirmation = false;
  }


  updateNumberOfAttendees() {
    if (!this.isOngoing) {
      return;
    }

    this.numberOfAttendeesPerMember = 0;

  }

  updateMaxGuests(event: EnumModel) {
    const { name } = event;
    if (name === 'Ongoing' && this.model.isMembershipCard) {
      this.numberOfAttendeesPerMember = 0;
    }

  }

  private saveInitialState() {
    this.initialState =
      JSON.stringify(this.timeFrom) +
      JSON.stringify(this.timeTo) +
      JSON.stringify(this.dateTo) +
      JSON.stringify(this.dateFrom) +
      JSON.stringify(this.selectedEventType) +
      JSON.stringify(this.deadlineDate) +
      JSON.stringify(this.deadlineTime) +
      JSON.stringify(this.numberOfAttendees) +
      JSON.stringify(this.numberOfAttendeesPerMember) +
      JSON.stringify(this.description) +
      JSON.stringify(this.address) +
      JSON.stringify(this.name) +
      JSON.stringify(this.images) +
      JSON.stringify(this.latitude) +
      JSON.stringify(this.longitude) +
      JSON.stringify(this.isAlive) +
      JSON.stringify(this.selectedMailChimpTemplates) +
      JSON.stringify(this.selectedFollowupOption) +
      JSON.stringify(this.appResponseAttending) +
      JSON.stringify(this.appResponseWaitingList);

  }

  private StateChanged() {
    const currentState =
      JSON.stringify(this.timeFrom) +
      JSON.stringify(this.timeTo) +
      JSON.stringify(this.dateTo) +
      JSON.stringify(this.dateFrom) +
      JSON.stringify(this.selectedEventType) +
      JSON.stringify(this.deadlineDate) +
      JSON.stringify(this.deadlineTime) +
      JSON.stringify(this.numberOfAttendees) +
      JSON.stringify(this.numberOfAttendeesPerMember) +
      JSON.stringify(this.description) +
      JSON.stringify(this.address) +
      JSON.stringify(this.name) +
      JSON.stringify(this.images) +
      JSON.stringify(this.latitude) +
      JSON.stringify(this.longitude) +
      JSON.stringify(this.isAlive) +
      JSON.stringify(this.selectedMailChimpTemplates) +
      JSON.stringify(this.selectedFollowupOption) +
      JSON.stringify(this.appResponseAttending) +
      JSON.stringify(this.appResponseWaitingList);

    return currentState !== this.initialState || currentState.length !== this.initialState.length;
  }

  setAppResponseValue(value) {
    this.appResponseAttending = value;
  }

  setAppWaitingListValue(value) {
    this.appResponseWaitingList = value;
  }

  setDescriptionValue(value) {
    this.description = value;
  }

  get isOngoing() {
    const isOngoing = this.selectedEventType && this.selectedEventType.id == 'true';
    if (isOngoing) this.numberOfAttendeesPerMember = 0;
    return isOngoing;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/events/event-details/event-details.component.ts